import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { CookieConsentsState } from './CookieConsentsState';

const initialState: CookieConsentsState = {
  acceptedCookieConsents: [],
  serverVersion: '',
  clientVersion: '',
  versionMatch: false
};

export interface SetAcceptedCookieConsentsPayload {
  readonly acceptedCookieConsents: string[];
}
export interface SetVersionsPayload {
  readonly serverVersion: string;
  readonly clientVersion: string;
}

export const cookieConsentsSlice = createSlice({
  name: 'cookieConsents',
  initialState,
  reducers: {
    setAcceptedCookieConsents(state, { payload }: PayloadAction<SetAcceptedCookieConsentsPayload>) {
      state.acceptedCookieConsents = payload.acceptedCookieConsents;
    },
    setVersions(state, { payload }: PayloadAction<SetVersionsPayload>) {
      state.serverVersion = payload.serverVersion;
      state.clientVersion = payload.clientVersion;
      state.versionMatch = payload.serverVersion === payload.clientVersion;
    }
  }
});

export const { setAcceptedCookieConsents, setVersions } = cookieConsentsSlice.actions;
export default cookieConsentsSlice.reducer;
